const colors = {
  // siteBackground: "#F9FAFC", //this is being set in the index.html

  white: "#FFFFFF",
  black: "#000000",

  siteBackground: "#F9FAFC",
  blue: "#1565C0",
  blueSlate: "#293241",
  blueDark: "#3D5980",
  blueLight: "#98C1D9",
  blueMedLight: "#2caffd",
  blueButtonBackground: "#d9e5ff",

  orange: "#EE6C4D",
  redError: "#D32F2F",
  redLightError: "#FFD3D7",
  green: "#4CAF50",
  greenSuccess: "#2E7D32",
  greenLightSuccess: "#C0D8C1",
  greenLightestSuccess: "#f1f8e9",
  greenFill: "#A6D7A8",

  guageGreenStart: "#3cb51a",
  guageGreenEnd: "#6edb3a",
  guageRedStart: "#b51a1a",
  guageRedEnd: "#db3a3a",
  guageBackground: "#e1e1e1",

  yellow: "#ff9f12",
  yellowLight: "#fff7ea",
  yellowTableRowWarning: "#fffaf0",

  gray: "#BBBBBB",
  grayDark: "#757575",
  grayLight: "#D8D8D8",
  grayLightest: "#FAFAFA",
  grayTableRowDisabled: "#f0f0f0",

  grayDarkText: "#4D4D4D",

  purpleLight: "#F1EDFF",
  purple: "#615ec9",
};

export default colors;
